<template>
  <div class="row">
    <!-- ===================================================== -->
    <!-- PROJECT INFO -->
    <!-- ===================================================== -->

    <div class="col-sm-12 mb-3">
      <div class="card border-0 project-info-card">
        <div class="card-body p-0">
          <div class="project-info-grid">
            <!-- PROYEK -->
            <div class="info-item">
              <div class="info-icon icon-primary">
                <i class="uil uil-file-alt"></i>
              </div>

              <div class="info-content">
                <div class="info-label">
                  Proyek
                </div>

                <div class="info-value">
                  {{ detail.kode_proyek || '-' }}
                </div>

                <div
                  v-if="detail.nama_proyek"
                  class="info-subvalue"
                  :title="detail.nama_proyek"
                >
                  {{ detail.nama_proyek }}
                </div>
              </div>
            </div>

            <!-- TANGGAL KONTRAK -->
            <div class="info-item">
              <div class="info-icon icon-primary">
                <i class="uil uil-calendar-alt"></i>
              </div>

              <div class="info-content">
                <div class="info-label">
                  Tanggal Kontrak
                </div>

                <div class="info-value">
                  {{ dateFormat(detail.tanggal_mulai) }}
                  -
                  {{ dateFormat(detail.tanggal_berakhir) }}
                </div>
              </div>
            </div>

            <!-- MEKANISME -->
            <div class="info-item">
              <div class="info-icon icon-primary">
                <i class="uil uil-wallet"></i>
              </div>

              <div class="info-content">
                <div class="info-label">
                  Mekanisme Pembayaran
                </div>

                <div class="info-value">
                  {{ detail.mekanisme_pembayaran || '-' }}
                </div>
              </div>
            </div>

            <!-- JUMLAH TAHAPAN -->
            <div class="info-item">
              <div class="info-icon icon-primary">
                <i class="uil uil-list-ul"></i>
              </div>

              <div class="info-content">
                <div class="info-label">
                  Jumlah Tahapan
                </div>

                <div class="info-value">
                  {{ detail.jumlah_tahapan_pembayaran || '0' }}
                </div>
              </div>
            </div>

            <!-- NILAI KONTRAK -->
            <div class="info-item">
              <div class="info-icon icon-primary">
                <i class="uil uil-money-bill"></i>
              </div>

              <div class="info-content">
                <div class="info-label">
                  Nilai Kontrak
                </div>

                <div class="info-value">
                  {{ formatRupiah(detail.nilai_kontrak_belum_ppn) }}
                </div>
              </div>
            </div>

            <!-- NILAI PRORATE -->
            <div class="info-item">
              <div class="info-icon icon-primary">
                <i class="uil uil-calculator"></i>
              </div>

              <div class="info-content">
                <div class="info-label">
                  Nilai Prorate
                </div>

                <div class="info-value">
                  {{ formatRupiah(detail.nilai_kontrak_prorate) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================================================== -->
    <!-- DOKUMEN -->
    <!-- ===================================================== -->

    <div class="col-sm-12">
      <div class="document-section">
        <div class="document-section-header">
          <div>
            <h5 class="document-title">
              Dokumen Proyek
            </h5>

            <small class="document-subtitle">
              Kelola dokumen dan berkas proyek
              {{ detail.nama_proyek }}
            </small>
          </div>
        </div>

        <div class="document-grid">
          <div
            v-for="(item, index) in dokumens"
            :key="'dokumen' + index"
            class="document-grid-item"
          >
            <div class="card card-file">
              <div
                class="card-file-thumb-2"
                :class="{
                  'document-exists': checkDokumen(item.tipe),
                }"
              >
                <div class="document-icon">
                  <i class="uil uil-file-bookmark-alt"></i>
                </div>

                <h1>
                  {{ item.name }}
                </h1>

                <div
                  v-if="checkDokumen(item.tipe)"
                  class="document-status"
                >
                  <i class="uil uil-check-circle"></i>
                  Tersedia
                </div>

                <div class="overlay-thumb">
                  <!-- LIST -->
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    :title="`Daftar Dokumen ${item.tipe}`"
                    @click="showModalList(item.tipe)"
                  >
                    <i class="fa fa-list"></i>
                  </button>

                  <!-- UPLOAD -->
                  <button
                    v-if="checkAuthorizedAll"
                    type="button"
                    class="btn btn-light btn-sm"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    :title="`Upload Dokumen ${item.tipe}`"
                    @click="showModalUpload(item.tipe, item.input)"
                  >
                    <i class="fa fa-upload"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================================================== -->
    <!-- MODAL UPLOAD -->
    <!-- ===================================================== -->

    <b-modal
      v-model="modalUpload"
      title-class="text-center"
      centered
      no-close-on-backdrop
      :title="`Upload Dokumen ${tipeDokumen}`"
    >
      <div>
        <div class="row">
          <!-- FILE -->
          <div class="form-group col-sm-12">
            <label>
              Dokumen

              <span
                v-if="fileDokumen === null"
                class="text-danger font-size-11 font-italic"
              >
                *Harus Diisi
              </span>
            </label>

            <input
              id="fileDokumen"
              ref="fileDokumen"
              class="form-control"
              type="file"
              accept="image/png, image/jpeg, .pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              @change="changeFile"
            />
          </div>

          <!-- TANGGAL -->
          <div
            v-if="inputDokumen"
            class="form-group col-sm-12"
          >
            <label>
              Tgl. Dokumen

              <span
                v-if="tanggalDokumen === ''"
                class="text-danger font-size-11 font-italic"
              >
                *Harus Diisi
              </span>
            </label>

            <date-picker
              v-model="tanggalDokumen"
              :config="{
                format: 'DD-MM-YYYY',
              }"
            />
          </div>

          <!-- NOMOR -->
          <div
            v-if="inputDokumen"
            class="form-group col-sm-12"
          >
            <label>
              No Dokumen

              <span
                v-if="noDokumen === ''"
                class="text-danger font-size-11 font-italic"
              >
                *Harus Diisi
              </span>
            </label>

            <input
              v-model="noDokumen"
              type="text"
              class="form-control"
            />
          </div>

          <!-- KETERANGAN -->
          <div
            v-if="inputDokumen"
            class="form-group col-sm-12"
          >
            <label>
              Keterangan

              <span
                v-if="keterangan === ''"
                class="text-danger font-size-11 font-italic"
              >
                *Harus Diisi
              </span>
            </label>

            <b-form-textarea
              id="textarea"
              v-model="keterangan"
              rows="3"
              max-rows="3"
              no-resize
            />
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button
          variant="outline-primary"
          @click="modalUpload = false"
        >
          Close
        </b-button>

        <button
          type="button"
          class="btn btn-primary btn-sm p-2 ml-2 pl-4 pr-4"
          :disabled="checkValidationFile"
          @click="upload"
        >
          <i class="uil uil-upload mr-1"></i>
          Upload
        </button>
      </template>
    </b-modal>

    <!-- ===================================================== -->
    <!-- MODAL LIST DOKUMEN -->
    <!-- ===================================================== -->

    <b-modal
      v-model="modalList"
      title-class="text-center"
      centered
      no-close-on-backdrop
      :title="`List Dokumen ${tipeDokumen}`"
    >
      <div class="row">
        <div class="col-sm-12">
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead>
                <tr>
                  <th class="text-center">
                    No
                  </th>

                  <th>
                    No Dokumen
                  </th>

                  <th>
                    Tgl. Dokumen
                  </th>

                  <th class="text-center">
                    Aksi
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(item, index) in typeDokumens"
                  :key="index"
                >
                  <td class="text-center">
                    {{ index + 1 }}
                  </td>

                  <td>
                    {{ item.no_dokumen || '-' }}
                  </td>

                  <td>
                    {{ dateFormat(item.tanggal_dokumen) }}
                  </td>

                  <td class="text-center">
                    <!-- PREVIEW -->
                    <button
                      v-if="isPdf(item.url)"
                      type="button"
                      class="btn btn-sm btn-info mr-1"
                      title="Preview PDF"
                      @click="previewPdf(item.id, item.url)"
                    >
                      <i class="fa fa-eye"></i>
                    </button>

                    <!-- DOWNLOAD -->
                    <button
                      type="button"
                      class="btn btn-sm btn-primary mr-1"
                      title="Download"
                      @click="download(item.id, item.url)"
                    >
                      <i class="fa fa-download"></i>
                    </button>

                    <!-- DELETE -->
                    <button
                      v-if="checkAuthorized"
                      type="button"
                      class="btn btn-sm btn-danger"
                      title="Hapus"
                      @click="removeData(item.id)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>

                <tr v-if="!typeDokumens.length">
                  <td
                    colspan="4"
                    class="text-center text-muted py-3"
                  >
                    Belum ada dokumen
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button
          variant="outline-primary"
          @click="modalList = false"
        >
          Close
        </b-button>
      </template>
    </b-modal>

    <!-- ===================================================== -->
    <!-- MODAL PREVIEW PDF -->
    <!-- ===================================================== -->

    <b-modal
      v-model="modalPreviewPdf"
      size="xl"
      centered
      no-close-on-backdrop
      hide-footer
      modal-class="modal-print"
      :title="`Preview Dokumen ${previewPdfTitle}`"
      @hidden="closePdfPreview"
    >
      <div class="pdf-preview-wrapper">
        <!-- ================================================= -->
        <!-- PDF IFRAME -->
        <!-- ================================================= -->

        <iframe
          v-if="previewPdfUrl"
          :key="previewPdfUrl"
          :src="previewPdfUrl"
          class="pdf-preview-frame"
          title="Preview PDF"
          @load="onPdfLoaded"
        ></iframe>

        <!-- ================================================= -->
        <!-- LOADING -->
        <!-- ================================================= -->

        <div
          v-if="loadingPreviewPdf"
          class="pdf-preview-loading"
        >
          <div class="pdf-loading-content">
            <b-spinner
              variant="primary"
              style="width: 3rem; height: 3rem"
            />

            <div class="pdf-loading-title">
              Memuat Dokumen PDF
            </div>

            <div class="pdf-loading-subtitle">
              Mohon tunggu sebentar...
            </div>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- EMPTY -->
        <!-- ================================================= -->

        <div
          v-if="!loadingPreviewPdf && !previewPdfUrl"
          class="pdf-preview-empty"
        >
          <i class="uil uil-file-times"></i>

          <div>
            Dokumen PDF tidak tersedia
          </div>
        </div>
      </div>
    </b-modal>

    <!-- ===================================================== -->
    <!-- MODAL LOADING DOWNLOAD -->
    <!-- ===================================================== -->

    <b-modal
      v-model="loadingDownload"
      size="sm"
      centered
      hide-footer
      no-close-on-backdrop
      hide-header-close
      hide-header
      modal-class="modal-loading"
    >
      <div
        v-if="loadingDownload"
        class="col-sm-12 text-center"
      >
        <b-spinner
          style="width: 7rem; height: 7rem"
          label="Large Spinner"
          variant="primary"
        />

        <p class="mt-3 mb-0">
          Mohon Tunggu Sebentar, Dokumen Dalam Proses Download
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { crudMethods } from '@/src/state/helpers'
import moment from 'moment'
import DatePicker from 'vue-bootstrap-datetimepicker'

export default {
  components: {
    DatePicker,
  },

  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  data() {
    return {
      items: [],
      detail: {},

      dokumens: [
        {
          tipe: 'KL',
          name: 'KL',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'BAUT',
          name: 'BAUT',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'BASO',
          name: 'BASO',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'P8',
          name: 'P8',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'KFS',
          name: 'KFS',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'BA-SPLITTING',
          name: 'BA-SPLITTING',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'SPH',
          name: 'SPH',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'SKES',
          name: 'SKES',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'BAST',
          name: 'BAST',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'BARD',
          name: 'BARD',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'BAPLA',
          name: 'BAPLA',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'BAPL',
          name: 'BAPL',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'RC',
          name: 'RC',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'NPK',
          name: 'NPK',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'NOKES',
          name: 'NOKES',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'PO',
          name: 'PO',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'EVIDENCE',
          name: 'EVIDENCE',
          input: true,
          owner: 'ADMINISTRASI',
        },
        {
          tipe: 'DLL',
          name: 'DLL',
          input: true,
          owner: 'ADMINISTRASI',
        },
      ],

      typeDokumens: [],

      modalList: false,
      modalUpload: false,

      fileDokumen: null,
      noDokumen: '',
      keterangan: '',
      tanggalDokumen: '',
      tipeDokumen: '',
      inputDokumen: false,

      // Download
      loadingDownload: false,

      // PDF Preview
      modalPreviewPdf: false,
      previewPdfUrl: '',
      previewPdfTitle: '',
      loadingPreviewPdf: false,
    }
  },

  computed: {
    checkAuthorizedAll() {
      return (
        this.user.role === 'ROOT' ||
        this.user.role === 'ADMIN' ||
        this.user.role === 'KABAG-SALES-DELIVERY' ||
        this.user.role === 'KABAG-ADMINISTRASI-NON-AKSES' ||
        this.user.role === 'SUPPORT-ADMINISTRASI-NON-AKSES'
      )
    },

    checkAuthorized() {
      return (
        this.user.role === 'ROOT' ||
        this.user.role === 'ADMIN' ||
        this.user.role === 'KABAG-SALES-DELIVERY' ||
        this.user.role === 'KABAG-ADMINISTRASI-NON-AKSES'
      )
    },

    checkValidationFile() {
      return (
        this.fileDokumen === null ||
        (this.inputDokumen && this.noDokumen === '') ||
        (this.inputDokumen && this.keterangan === '') ||
        (this.inputDokumen && this.tanggalDokumen === '')
      )
    },
  },

  mounted() {
    this.getDetail()
    this.getList()
  },

  methods: {
    ...crudMethods,

    // =======================================================
    // DETAIL
    // =======================================================

    getDetail() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}`,
      }).then((response) => {
        const { data } = response.data

        this.detail = data
      })
    },

    // =======================================================
    // LIST DOKUMEN
    // =======================================================

    getList() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/dokumen`,
      }).then((response) => {
        const { data } = response.data

        this.items = data
      })
    },

    checkDokumen(id) {
      let val = false

      this.items.forEach((item) => {
        if (item.tipe === id) {
          val = true
        }
      })

      return val
    },

    getDokumen(tipe) {
      return this.items.find((x) => x.tipe === tipe)
    },

    // =======================================================
    // UPLOAD
    // =======================================================

    showModalUpload(tipe, input) {
      this.tipeDokumen = tipe
      this.inputDokumen = input
      this.modalUpload = true
    },

    showModalList(tipe) {
      this.tipeDokumen = tipe
      this.modalList = true

      this.listDokumens()
    },

    formatBytes(bytes, decimals = 0) {
      if (bytes === 0) return '0 GB'

      if (isNaN(parseInt(bytes))) {
        return bytes
      }

      if (typeof bytes === 'string') {
        bytes = parseInt(bytes)
      }

      if (bytes === 0) return '0'

      const k = 1000
      const dm = decimals + 1 || 3
      const sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB',
      ]

      const i = Math.floor(
        Math.log(bytes) / Math.log(k)
      )

      return `${parseFloat(
        (bytes / k ** i).toFixed(dm)
      )} ${sizes[i]}`
    },

    changeFile(event) {
      this.fileDokumen = event.target.files[0]
    },

    listDokumens() {
      this.getData({
        url: `web/transaksi/proyek/${
          this.$route.params.id
        }/dokumen/${this.tipeDokumen.toUpperCase()}/all`,
      }).then((response) => {
        const { data } = response.data

        this.typeDokumens = data
      })
    },

    upload() {
      const body = new FormData()

      body.append('dokumen', this.fileDokumen)
      body.append('tipe', this.tipeDokumen)
      body.append('no_dokumen', this.noDokumen)

      body.append(
        'tanggal_dokumen',
        moment(
          this.tanggalDokumen,
          'DD-MM-YYYY'
        ).format('YYYY-MM-DD')
      )

      body.append(
        'keterangan',
        this.keterangan
      )

      this.insertData({
        url: `web/transaksi/proyek/${this.$route.params.id}/dokumen`,
        body: body,
      })
        .then(() => {
          this.modalUpload = false

          this.fileDokumen = null
          this.noDokumen = ''
          this.keterangan = ''
          this.tanggalDokumen = ''

          if (this.$refs.fileDokumen) {
            this.$refs.fileDokumen.value = ''
          }

          this.toast(
            'b-toaster-bottom-right',
            true,
            'Dokumen Berhasil Diupload'
          )

          this.getList()
        })
        .catch((err) => {
          let message = JSON.parse(
            err.response.request.response
          )

          this.errorMsg = message.message
          this.modalError = true
        })
    },

    // =======================================================
    // DOWNLOAD
    // =======================================================

    download(id, name) {
      this.modalList = false
      this.loadingDownload = true

      this.downloadData({
        url: `web/transaksi/proyek/${this.$route.params.id}/dokumen/${id}`,
      })
        .then((response) => {
          this.loadingDownload = false

          const url = window.URL.createObjectURL(
            new Blob([response.data])
          )

          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', name)

          document.body.appendChild(link)

          link.click()

          document.body.removeChild(link)

          window.URL.revokeObjectURL(url)
        })
        .catch((err) => {
          console.log(err)

          this.loadingDownload = false

          this.toast(
            'b-toaster-bottom-right',
            true,
            'Dokumen Gagal Didownload'
          )
        })
    },

    // =======================================================
    // PDF
    // =======================================================

    isPdf(name) {
      if (!name) {
        return false
      }

      return String(name)
        .split('?')[0]
        .toLowerCase()
        .endsWith('.pdf')
    },

    previewPdf(id, name) {
      // Tutup list terlebih dahulu
      this.modalList = false

      // Bersihkan PDF sebelumnya
      this.closePdfPreview()

      // Set title
      this.previewPdfTitle = name || 'PDF'

      // Tampilkan loading
      this.loadingPreviewPdf = true

      // Buka modal terlebih dahulu
      this.modalPreviewPdf = true

      // Request PDF
      this.downloadData({
        url: `web/transaksi/proyek/${this.$route.params.id}/dokumen/${id}`,
      })
        .then((response) => {
          const blob = new Blob(
            [response.data],
            {
              type: 'application/pdf',
            }
          )

          // Buat URL blob
          this.previewPdfUrl =
            window.URL.createObjectURL(blob)
        })
        .catch((err) => {
          console.log(err)

          this.loadingPreviewPdf = false
          this.modalPreviewPdf = false

          this.toast(
            'b-toaster-bottom-right',
            true,
            'Dokumen PDF Tidak Dapat Dibuka'
          )
        })
    },

    onPdfLoaded() {
      this.loadingPreviewPdf = false
    },

    closePdfPreview() {
      this.loadingPreviewPdf = false

      if (this.previewPdfUrl) {
        window.URL.revokeObjectURL(
          this.previewPdfUrl
        )
      }

      this.previewPdfUrl = ''
      this.previewPdfTitle = ''
    },

    // =======================================================
    // DELETE
    // =======================================================

    removeData(id) {
      this.$bvModal
        .msgBoxConfirm(
          'Apakah anda yakin ingin menghapus dokumen ini?',
          {
            title: 'Mohon Konfirmasi',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YA',
            cancelTitle: 'TIDAK',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.deleteData({
              url: `web/transaksi/proyek/${this.$route.params.id}/dokumen/${id}`,
            })
              .then((response) => {
                const { data } = response

                if (data) {
                  this.listDokumens()
                  this.getList()

                  this.toast(
                    'b-toaster-bottom-right',
                    true,
                    'Berhasil Dihapus'
                  )
                }
              })
              .catch((err) => {
                console.log(err)

                this.errorMsg =
                  'Maaf, Data Ini Tidak Dapat Dihapus'

                this.modalError = true
              })
          }
        })
    },

    // =======================================================
    // FORMAT
    // =======================================================

    dateFormat(value) {
      if (!value) {
        return '-'
      }

      moment.locale('id')

      return moment(value).format(
        'DD MMMM YYYY'
      )
    },

    formatRupiah(value) {
      return `Rp ${Number(
        value || 0
      ).toLocaleString('id-ID')}`
    },

    // =======================================================
    // TOAST
    // =======================================================

    toast(
      toaster,
      append = false,
      body
    ) {
      this.$bvToast.toast(
        `Data Dokumen ${body}`,
        {
          title: 'Data Dokumen',
          toaster: toaster,
          solid: true,
          appendToast: append,
          variant: 'success',
        }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
/* =========================================================
   PROJECT INFO
   ========================================================= */

.project-info-card {
  border: 1px solid #cfe2ff !important;
  border-radius: 8px;
  background: #f8fbff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.project-info-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.info-item {
  display: flex;
  align-items: center;

  min-width: 0;
  min-height: 92px;

  padding: 12px 15px;

  border-right: 1px solid #dbe7f5;
  border-bottom: 0;
}

.info-item:last-child {
  border-right: 0;
}

/* =========================================================
   INFO ICON
   ========================================================= */

.info-icon {
  flex: 0 0 40px;

  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 12px;

  border-radius: 50%;

  font-size: 20px;
}

.icon-primary {
  color: #3867f0;
  background: #e8f1ff;
}

.icon-success {
  color: #20bf82;
  background: #e2f7ed;
}

.icon-warning {
  color: #3867f0;
  background: #e8f1ff;
}

.icon-danger {
  color: #f46a6a;
  background: #fdeaea;
}

/* =========================================================
   INFO CONTENT
   ========================================================= */

.info-content {
  min-width: 0;
  flex: 1;
}

.info-label {
  margin-bottom: 3px;

  color: #53627a;

  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}

.info-value {
  color: #15213b;

  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;

  word-break: break-word;
}

.info-subvalue {
  margin-top: 2px;

  color: #7c8799;

  font-size: 11px;
  line-height: 1.3;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =========================================================
   DOCUMENT SECTION
   ========================================================= */

.document-section {
  width: 100%;
}

.document-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 12px;
}

.document-title {
  margin: 0;

  color: #15213b;

  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
}

.document-subtitle {
  color: #53627a;

  font-size: 11px;
  line-height: 1.4;
}

.document-grid {
  display: grid;

  grid-template-columns: repeat(
    6,
    minmax(0, 1fr)
  );

  gap: 10px;
}

.document-grid-item {
  min-width: 0;
}

/* =========================================================
   DOCUMENT CARD
   ========================================================= */

.card-file {
  position: relative;

  height: 100%;

  margin-bottom: 0;
  padding: 0;

  border: 1px solid #dbe7f5;
  border-radius: 8px;

  background: #fff;

  overflow: hidden;

  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.04);

  transition:
    transform 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
}

.card-file:hover {
  transform: translateY(-2px);

  border-color: #cfe2ff;

  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.card-file-thumb-2 {
  position: relative;

  height: 115px;

  padding: 10px 8px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  background: #f8fbff;
  color: #98a6ad;
}

.card-file-thumb-2.document-exists {
  color: #3867f0;

  background: rgba(
    85,
    110,
    230,
    0.04
  );
}

.document-icon {
  margin-bottom: 6px;

  color: #98a6ad;

  font-size: 38px;
  line-height: 1;
}

.card-file-thumb-2.document-exists
  .document-icon {
  color: #3867f0;
}

.card-file-thumb-2 h1 {
  max-width: 100%;

  margin: 0;

  color: #343a40;

  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;

  word-break: break-word;
}

.card-file-thumb-2.document-exists
  h1 {
  color: #3867f0;
}

/* =========================================================
   DOCUMENT STATUS
   ========================================================= */

.document-status {
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 4px;

  margin-top: 5px;

  color: #20bf82;

  font-size: 10px;
  font-weight: 600;
  line-height: 1;
}

.document-status i {
  font-size: 11px;
}

/* =========================================================
   OVERLAY
   ========================================================= */

.overlay-thumb {
  display: none;

  position: absolute;
  inset: 0;

  align-items: center;
  justify-content: center;

  gap: 7px;

  background-color: rgba(
    21,
    33,
    59,
    0.72
  );
}

.card-file-thumb-2:hover
  .overlay-thumb {
  display: flex;
}

.overlay-thumb .btn {
  width: 34px;
  height: 34px;

  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 6px;

  box-shadow: none;
}

.overlay-thumb .btn i {
  font-size: 13px;
}

/* =========================================================
   PDF PREVIEW MODAL
   ========================================================= */

.modal-pdf-preview
  ::v-deep
  .modal-dialog {
  max-width: 1200px;

  width: calc(100% - 30px);
}

.modal-pdf-preview
  ::v-deep
  .modal-body {
  padding: 10px;
}

/* =========================================================
   PDF PREVIEW WRAPPER
   ========================================================= */

.pdf-preview-wrapper {
  position: relative;

  width: 100%;

  height: 100%;

  min-height: 500px;

  overflow: hidden;

  background: #f5f6f8;

  border-radius: 6px;
}

/* =========================================================
   PDF IFRAME
   ========================================================= */

.pdf-preview-frame {
  display: block;

  width: 100%;
  height: 100%;

  border: 0;

  background: #fff;
}

/* =========================================================
   PDF LOADING
   ========================================================= */

.pdf-preview-loading {
  position: absolute;

  inset: 0;

  z-index: 10;

  display: flex;

  align-items: center;
  justify-content: center;

  background: rgba(
    248,
    249,
    250,
    0.96
  );
}

.pdf-loading-content {
  display: flex;

  flex-direction: column;

  align-items: center;
  justify-content: center;

  text-align: center;
}

.pdf-loading-title {
  margin-top: 18px;

  color: #15213b;

  font-size: 15px;
  font-weight: 600;
}

.pdf-loading-subtitle {
  margin-top: 4px;

  color: #7c8799;

  font-size: 12px;
}

/* =========================================================
   PDF EMPTY
   ========================================================= */

.pdf-preview-empty {
  position: absolute;

  inset: 0;

  display: flex;

  flex-direction: column;

  align-items: center;
  justify-content: center;

  color: #98a6ad;

  font-size: 13px;

  text-align: center;
}

.pdf-preview-empty i {
  margin-bottom: 10px;

  font-size: 42px;
}

/* =========================================================
   TABLET
   ========================================================= */

@media (max-width: 1199.98px) {
  .project-info-grid {
    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );
  }

  .info-item {
    min-height: 92px;

    padding: 12px 14px;

    border-right: 1px solid
      #dbe7f5;

    border-bottom: 1px solid
      #dbe7f5;
  }

  .info-item:nth-child(3n) {
    border-right: 0;
  }

  .info-item:nth-last-child(-n + 3) {
    border-bottom: 0;
  }

  .document-grid {
    grid-template-columns:
      repeat(
        4,
        minmax(0, 1fr)
      );

    gap: 10px;
  }

  .card-file-thumb-2 {
    height: 115px;
  }
}

/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 767.98px) {
  .modal-pdf-preview
    ::v-deep
    .modal-dialog {
    width: calc(100% - 10px);

    max-width: none;

    margin: 5px auto;
  }

  .modal-pdf-preview
    ::v-deep
    .modal-body {
    padding: 5px;
  }

  .pdf-preview-wrapper {
    height: 75vh;

    min-height: 400px;
  }

  .project-info-grid {
    grid-template-columns:
      repeat(
        2,
        minmax(0, 1fr)
      );
  }

  .info-item:nth-child(3n) {
    border-right: 1px solid
      #dbe7f5;
  }

  .info-item:nth-child(2n) {
    border-right: 0;
  }

  .info-item:nth-last-child(-n + 3) {
    border-bottom: 1px solid
      #dbe7f5;
  }

  .info-item:nth-last-child(-n + 2) {
    border-bottom: 0;
  }

  .info-item {
    min-height: 82px;

    padding: 11px 12px;
  }

  /* ICON */

  .info-icon {
    flex: 0 0 34px;

    width: 34px;
    height: 34px;

    margin-right: 9px;

    font-size: 17px;
  }

  /* TEXT */

  .info-label {
    margin-bottom: 2px;

    font-size: 11px;
  }

  .info-value {
    font-size: 14px;
  }

  .info-subvalue {
    font-size: 10px;
  }

  /* DOCUMENT */

  .document-section-header {
    margin-bottom: 10px;
  }

  .document-title {
    font-size: 14px;
  }

  .document-subtitle {
    font-size: 10px;
  }

  .document-grid {
    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );

    gap: 8px;
  }

  .card-file-thumb-2 {
    height: 105px;

    padding: 8px 6px;
  }

  .document-icon {
    margin-bottom: 5px;

    font-size: 34px;
  }

  .card-file-thumb-2 h1 {
    font-size: 12px;
  }

  .document-status {
    font-size: 9px;
  }

  .document-status i {
    font-size: 10px;
  }

  .overlay-thumb {
    gap: 6px;
  }

  .overlay-thumb .btn {
    width: 30px;
    height: 30px;
  }

  .overlay-thumb .btn i {
    font-size: 11px;
  }
}

/* =========================================================
   EXTRA SMALL
   ========================================================= */

@media (max-width: 575.98px) {
  .project-info-grid {
    grid-template-columns: 1fr;
  }

  .info-item,
  .info-item:nth-child(2n),
  .info-item:nth-child(3n) {
    border-right: 0 !important;

    border-bottom:
      1px solid #dbe7f5 !important;
  }

  .info-item:last-child {
    border-bottom: 0 !important;
  }

  .info-item {
    min-height: 72px;

    padding: 10px 12px;
  }

  /* DOCUMENT */

  .document-grid {
    grid-template-columns:
      repeat(
        2,
        minmax(0, 1fr)
      );

    gap: 8px;
  }

  .card-file-thumb-2 {
    height: 100px;

    padding: 7px;
  }

  .document-icon {
    font-size: 32px;
  }

  .card-file-thumb-2 h1 {
    font-size: 11px;
  }

  .document-status {
    font-size: 9px;
  }

  .document-status i {
    font-size: 10px;
  }

  .pdf-preview-wrapper {
    height: 78vh;
    width: 100%;

    min-height: 350px;
  }
}
</style>